import React, { useEffect, useRef } from 'react';
import { Select } from 'antd';
import './public-component.less';

interface SearchSelectComponentProps {
    optionProps: SearchSelectOption[];
    onChange?: (key: any, value: any) => void;
    onClear?: () => void; 
    placeholder?: string;
    initialValues?: any;
    disabled?: boolean;
    allowClear?: boolean;
    returnInputValue?: boolean;
    debounceTime?: number;
    className?: string;
}
  
export interface SearchSelectOption {
    key: any;
    value: any;
}

const filterOption = (input, option) => {
    if (option.children) {
      return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
    return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

const SearchSelectComponent: React.FC<SearchSelectComponentProps> = ({ 
    onChange, 
    optionProps, 
    placeholder, 
    initialValues, 
    disabled, 
    allowClear,
    onClear,
    returnInputValue = false,
    debounceTime = 500,
    className,
    }) => {
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);

    const handleStatesSelectChange = (selectedKey: any, option: any) => {
        if (selectedKey === undefined || selectedKey === null) {
            // 当选择被清空时
            onClear && onClear();
            return;
        }
        // 找到选中项对应的完整数据
        const selectedOption = optionProps.find(item => item.key === selectedKey);
        if (selectedOption && onChange) {
            // 调用 onChange 时传入 key 和 value
            onChange(selectedOption.key, selectedOption.value);
        }
    };

    // 处理搜索框内容变化，使用防抖
    const handleSearch = (value: string) => {
        if (returnInputValue && onChange && value) {
            // 清除之前的定时器
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
            
            // 设置新的定时器
            debounceTimerRef.current = setTimeout(() => {
                onChange(value, value);
            }, debounceTime);
        }
    };

    return (
        <>
            <Select 
                className={`search-select${className ? ` ${className}` : ''}`}
                showSearch
                optionFilterProp="children"
                placeholder={placeholder}
                onChange={handleStatesSelectChange}
                onSearch={handleSearch}
                allowClear={allowClear}
                filterOption={filterOption}      
                defaultValue={initialValues ? initialValues : undefined}
                disabled={disabled}
            >     
                {optionProps && optionProps.map((option) => (
                    <Select.Option key={option.key} value={option.key}>
                        {option.value}
                    </Select.Option>
                ))}
            </Select>   
        </>
    );
}

export default SearchSelectComponent;
